import { render, staticRenderFns } from "./KSzhTable.vue?vue&type=template&id=698b8bac&scoped=true"
import script from "./KSzhTable.vue?vue&type=script&lang=js"
export * from "./KSzhTable.vue?vue&type=script&lang=js"
import style0 from "./KSzhTable.vue?vue&type=style&index=0&id=698b8bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698b8bac",
  null
  
)

export default component.exports